
import React from 'react';
import { cn } from '@/lib/utils';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

interface ServiceCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  color?: string;
  onClick?: () => void;
  className?: string;
  to: string;
}

const ServiceCard: React.FC<ServiceCardProps> = ({
  title,
  description,
  icon,
  color,
  onClick,
  className,
  to,
}) => {
  // Map colors to button variants
  const getButtonVariant = () => {
    if (color?.includes('indigo')) return 'indigo';
    if (color?.includes('pink')) return 'pink';
    if (color?.includes('purple')) return 'purple';
    if (color?.includes('blue')) return 'blue';
    if (color?.includes('emerald')) return 'emerald';
    if (color?.includes('amber')) return 'amber';
    if (color?.includes('rose')) return 'rose';
    if (color?.includes('teal')) return 'teal';
    if (color?.includes('cyan')) return 'cyan';
    return 'default';
  };

  return (
    <Link 
      to={to}
      className="block"
      onClick={onClick}
    >
      <div 
        className={cn(
          "menu-card group p-4 animate-scale-in transition-all duration-300 hover:scale-105 cursor-pointer",
          className
        )}
        style={{ 
          animationDelay: Math.random() * 0.3 + 's',
          background: 'linear-gradient(to bottom right, #ffffff, #f8f9ff)',
          boxShadow: `0 8px 20px ${color}15`,
          border: `1px solid ${color}25`,
          borderRadius: '16px',
        }}
      >
        <div 
          className="menu-card-icon rounded-xl mb-3 flex items-center justify-center w-14 h-14 transform transition-all duration-300" 
          style={{ 
            color: color,
            boxShadow: `0 8px 16px ${color}25`,
            background: `${color}15`,
          }}
        >
          {icon}
        </div>
        
        <h3 className="text-lg font-medium mb-1 group-hover:text-primary transition-colors">{title}</h3>
        <p className="text-sm text-muted-foreground mb-3">{description}</p>
        
        <Button 
          variant={getButtonVariant() as any} 
          size="sm" 
          className="w-full mt-2 transition-all duration-300"
        >
          {title}
        </Button>
      </div>
    </Link>
  );
};

export default ServiceCard;
